"use client"

import clsx from "clsx"
import { motion } from "framer-motion"
import React from "react"

import PageGrid from "../../PageGrid"

type NumberToutsHeroProps = {
  data:
    | {
        id: number
        heading: string
        paragraph: string
      }[]
    | any
}

const PageGridMotionComponent = motion(PageGrid, {
  forwardMotionProps: true,
})

const NumberToutsHero: React.FC<NumberToutsHeroProps> = ({ data }) => {
  const animationVariants = {
    hidden: {
      opacity: 0,
    },
    visible: (i: number) => ({
      opacity: 1,
      transition: {
        delay: i !== 0 ? 1.5 : 0.5,
        duration: i !== 0 ? 1.5 : 0.5,
      },
    }),
  }

  return (
    <section className="py-8 md:py-12 lg:py-36 bg-gradient-to-b from-blue-15 to-blue-2.5">
      <PageGridMotionComponent>
        {data.map((numberTout, index) => (
          <motion.div
            key={numberTout.heading}
            className="p-4 col-span-full md:col-span-2 lg:col-span-4"
            custom={index}
            whileInView="visible"
            viewport={{ once: true }}
            initial="hidden"
            variants={animationVariants}
          >
            <h2
              className={clsx(
                "headline3 lg:headline1",
                index === 0 ? "text-[#006AFF]" : "text-gray-90",
              )}
            >
              {numberTout.heading}
            </h2>
            <p
              className={clsx(
                "body2",
                index === 0 ? "text-[#006AFF]" : "text-gray-90",
              )}
            >
              {numberTout.paragraph}
            </p>
          </motion.div>
        ))}
      </PageGridMotionComponent>
    </section>
  )
}

export default NumberToutsHero
